export const RequestTracingComponent = {
    MountAsync: async (target: HTMLElement, props: Record<string, unknown>) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { RequestTracingPage } = await import('./RequestTracingPage');
        return await mountReactComponentAsync(target, RequestTracingPage, props);
    }
};
